import React from 'react'
import { Spinner } from 'react-bootstrap'

function Loading({ text }) {
    return (
        <div style={{ width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
                <div>

                    {text}
                </div>
            </div>
        </div>
    )
}

export default Loading